import React from "react";
import { Form, Input } from "semantic-ui-react";

import { RootState } from "../../store/SrciStore";
import * as action from "../../store/reducers/SrciInputData";
import { useAppSelector, useAppDispatch } from "../../store/hooks";

export default function DCF() {

  const srciInitVisa = useAppSelector((state: RootState) => state.srciInputData.srciInitVisa)
  const srciInitMastercard = useAppSelector((state: RootState) => state.srciInputData.srciInitMastercard)
  const dispatch = useAppDispatch()

  const handleOnChange = (e: any, element: any) => {
    dispatch(action.save({
      name: element.name,
      value: element.value
    }))
  }

  return (
    <React.Fragment>
      
      <Form>
        <Form.Group widths='equal'>
            <Form.Field>
                <label>Visa</label>
            </Form.Field>
            <Form.Field>
              <label>SRC initiator ID</label>
              <Input value={srciInitVisa.srcInitiatorId} name="srciInitVisa.srcInitiatorId" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
              <label>SRCi DPA ID</label>
              <Input value={srciInitVisa.srciDpaId} name="srciInitVisa.srciDpaId" onChange={handleOnChange} />
            </Form.Field>                 
        </Form.Group>

        <Form.Group widths='equal'>
            <Form.Field>
                <label>Mastercard</label>
            </Form.Field>
            <Form.Field>
              <label>SRC initiator ID</label>
              <Input value={srciInitMastercard.srcInitiatorId} name="srciInitMastercard.srcInitiatorId" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
              <label>SRCi DPA ID</label>
              <Input value={srciInitMastercard.srciDpaId} name="srciInitMastercard.srciDpaId" onChange={handleOnChange} />
            </Form.Field>                     
        </Form.Group>               
      </Form>
    </React.Fragment>
  );
}